import React, { Component } from "react";
import {
    MDBBtn,
    MDBModalBody,
    MDBModalHeader,
    MDBRow,
    MDBCol,
    MDBModal,
    toast,
    MDBProgress,
} from "mdbreact";
import CSVReader from "react-csv-reader";
import axios from "../../../../axios";
import SelectSearch, { fuzzySearch } from "react-select-search";
const papaparseOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
    quotes: true,
    encoding: "UTF-8",
    transformHeader: (header) => header.toLowerCase().replace(/\W/g, "_"),
};
class BulkUploadUnits extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lastProcessed: undefined,
        };
    }
    sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
    formatzip(num) {
        var s = "00000" + num;
        return s.substr(s.length - 5);
    }
    convertCSV = async (data) => {
        console.log("CSV Data parsed:", data);
        console.log("First row keys:", data[0] ? Object.keys(data[0]) : "No data");
        
        this.setState({ loading_upload: true });
        this.setState({ modalError: false });
        this.setState({
            unitUnprocessed: undefined,
            buildingUnprocessed: undefined,
            floorUnprocessed: undefined,
            lastProcessed: undefined,
            progress: 0
        });
        let dataImported = [];
        for (let i = 0; i < data.length; i++) {
            // Validate required fields
            const requiredFields = {
                "unit_id_": "Unit ID",
                "building_": "Building",
                "floor_": "Floor",
                "purpose__wiredunit_or_localwirelessonly__": "Purpose",
                "address_1_": "Address 1",
                "city_": "City",
                "state_": "State",
                "country_": "Country",
                "postal_code_": "Postal Code",
                "vlan": "VLAN"
            };
            
            const missingFields = [];
            for (const [field, label] of Object.entries(requiredFields)) {
                const value = data[i][field];
                // Check if value is missing, treating 0 as valid, empty string as invalid
                const isMissing = value === undefined || 
                                 value === null || 
                                 (typeof value === 'string' && value.trim() === "") ||
                                 (typeof value === 'number' && isNaN(value));
                
                if (isMissing) {
                    missingFields.push(label);
                    console.log(`Row ${i + 2}: Missing field '${field}' (${label}), value:`, value);
                }
            }
            
            if (missingFields.length > 0) {
                console.error("Available fields in row:", Object.keys(data[i]));
                console.error("Expected fields:", Object.keys(requiredFields));
                this.setState({
                    unitUnprocessed: data[i]["unit_id_"] || "N/A",
                    buildingUnprocessed: data[i]["building_"] || "N/A",
                    floorUnprocessed: data[i]["floor_"] || "N/A",
                    lastProcessed: i,
                    modalError: true,
                    errorMessage: `Missing required field(s): ${missingFields.join(", ")}. Please ensure you're using the correct Unit Upload template (not Subscriber template) and that all required fields are marked with asterisks (*) in the header row.`,
                    loading_upload: false
                });
                this.cancelUploadedFile();
                return;
            }
            
            if (
                data[i]["shopping_cart_price_adjustment"] !== null &&
                data[i]["shopping_cart_price_adjustment"] !== undefined &&
                data[i]["shopping_cart_price_adjustment"] !== "" &&
                isNaN(Number(data[i]["shopping_cart_price_adjustment"]))
            ) {
                this.setState({ loading_upload: false });
                this.cancelUploadedFile();
                this.toggleError();
                this.setState({
                 unitUnprocessed: data[i]["unit_id_"],
                 buildingUnprocessed: data[i]["building_"],
                 floorUnprocessed: data[i]["floor_"],
                 lastProcessed: i + 1,
             });
                this.setState({
                 modalError: true,
                 errorMessage: "Shopping Cart Price Adjustment on line " +
                        [i + 2] +
                        " must be a valid number, please check your upload file and try again",
             });
                return;
            }
            
            // Check if Shopping Cart Price Adjustment has more than 2 decimal places
            if (
                data[i]["shopping_cart_price_adjustment"] !== null &&
                data[i]["shopping_cart_price_adjustment"] !== undefined &&
                data[i]["shopping_cart_price_adjustment"] !== ""
            ) {
                const priceValue = Number(data[i]["shopping_cart_price_adjustment"]);
                const decimalPlaces = (priceValue.toString().split('.')[1] || '').length;
                if (decimalPlaces > 2) {
                    this.setState({ loading_upload: false });
                    this.cancelUploadedFile();
                    this.toggleError();
                    this.setState({
                        unitUnprocessed: data[i]["unit_id_"],
                        buildingUnprocessed: data[i]["building_"],
                        floorUnprocessed: data[i]["floor_"],
                        lastProcessed: i + 1,
                    });
                    this.setState({
                        modalError: true,
                        errorMessage: "Shopping Cart Price Adjustment on line " +
                            [i + 2] +
                            " has more than 2 decimal places. Please use at most 2 decimal places (e.g., 10.12)",
                    });
                    return;
                }
            }
            
            {
                dataImported[i] = {
                    VenueID: this.props.venueID,
                    UnitID: data[i]["unit_id_"].toString(),
                    UnitFloor: data[i]["floor_"].toString(),
                    UnitBuilding: data[i]["building_"].toString(),
                    AddressLine1: data[i]["address_1_"].toString(),
                    AddressLine2:
                        data[i]["address_2"] === null
                            ? ""
                            : data[i]["address_2"].toString(),
                    City: data[i]["city_"].toString(),
                    State: data[i]["state_"].toString(),
                    PostalCode:
                        data[i]["country_"] === "USA"
                            ? this.formatzip(data[i]["postal_code_"])
                            : data[i]["postal_code_"].toString(),
                    "Country.ISO3166A3": data[i]["country_"],
                    SharedSecret: this.props.sharedSecret,
                    AccessToken: sessionStorage.getItem("AccessToken"),
                    vlan: data[i]["vlan"].toString(),
                    purpose:
                        data[i][
                            "purpose__wiredunit_or_localwirelessonly__"
                        ].toLowerCase(),
                    ServicePlanID: data[i]["service_plan_id"],
                    UnitID_internal: data[i]["unit_internal_id"] ? data[i]["unit_internal_id"].toString() : "",
                    externalVenueUnitID: data[i]["unit_external_id"] ? data[i]["unit_external_id"].toString() : "",
                    ShoppingCartPriceAdjustment:
                    Math.round(-Math.abs(data[i]["shopping_cart_price_adjustment"] * 100))
                };
                let unitID = data[i]["unit_id_"];
                let building = data[i]["building_"];
                let floor = data[i]["floor_"];
                await axios
                    .post(
                        "/networkoperatorconsole/venues/addVenueUnits",
                        dataImported[i],
                        {
                            headers: {},
                        }
                    )
                    .then(
                        (response) => {
                            toast.success(
                                "Unit " +
                                    unitID +
                                    ", Building " +
                                    building +
                                    ", Floor " +
                                    floor +
                                    " processed",
                                {
                                    closeButton: false,
                                }
                            );
                            if (i + 1 === data.length) {
                                this.props.updateName(
                                    this.state.venueName,
                                    this.props.venueID
                                );
                            }
                        },
                        (error) => {
                            this.setState({
                                unitUnprocessed: unitID,
                                buildingUnprocessed: building,
                                floorUnprocessed: floor,
                                lastProcessed: i + 1,
                            });
                            this.cancelUploadedFile();
                            i = data.length;
                            this.setState({
                                modalError: true,
                                errorMessage: error.response.data.message,
                            });
                        }
                    );
                this.setState({ progress: ((i + 1) / data.length) * 100 });
            }
        }
        this.setState({ loading_upload: false });
    };
    cancelUploadedFile() {
        const randomString = Math.random().toString(36);
        this.setState({
            theInputKey: randomString,
        });
    }
    toggleError = () => {
        this.setState({
            modalError: !this.state.modalError,
        });
    };
    convertToCSV(objArray) {
        var array =
            typeof objArray != "object" ? JSON.parse(objArray) : objArray;
        var str = "";
        for (var i = 0; i < array.length; i++) {
            var line = "";
            for (var index in array[i]) {
                if (line !== "") line += ",";
                line += '"' + array[i][index] + '"';
            }
            str += line + "\r\n";
        }
        return str;
    }
    exportCSVFile(headersExport, items, fileTitle) {
        if (headersExport !== items[0]) {
            items.unshift(headersExport);
        }
        // Convert Object to JSON
        var jsonObject = JSON.stringify(items);
        var csv = this.convertToCSV(jsonObject);
        var exportedFilename = "Unit_Upload_Template.csv";
        // Add BOM for better UTF-8 compatibility with Excel
        var csvWithBOM = "\uFEFF" + csv;
        var blob = new Blob([csvWithBOM], { type: "text/csv;charset=utf-8;" });
        if (navigator.msSaveBlob) {
            // IE 10+
            navigator.msSaveBlob(blob, exportedFilename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) {
                // feature detection
                //
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", exportedFilename);
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }
    render() {
        var headers = {
            unitID: "Unit ID*",
            unitBuilding: "Building*",
            unitFloor: "Floor*",
            purpose: "Purpose (wiredunit or localwirelessonly)*",
            AddressLine1: "Address 1*",
            SubscriberAddress2: "Address 2",
            SubscriberCity: "City*",
            SubscriberState: "State*",
            SubscriberPostalCode: "Postal Code*",
            SubscriberCountry: "Country*",
            VLAN: "VLAN",
            // ServicePlanID: "Service Plan ID",
            unitIDInternal: "Unit Internal ID",
            externalVenueUnitID: "Unit External ID",
            ShoppingCartPriceAdjustment: "Shopping Cart Price Adjustment",
        };
        var itemsFormatted = [];
        var fileTitle = sessionStorage.getItem("venueName"); // or 'my-unique-title'
        return (
            <>
                {this.state.lastProcessed !== undefined ? (
                    <>
                        <MDBModal
                            isOpen={this.state.modalError}
                            toggle={this.toggleError}
                            size="md"
                            className="form"
                            centered
                        >
                            <MDBModalHeader toggle={this.toggleError}>
                                <h4>Error Uploading Units</h4>
                            </MDBModalHeader>
                            <MDBModalBody>
                                {this.state.lastProcessed === 0 ? (
                                    <p>
                                        Line {this.state.lastProcessed + 2}{" "}
                                        (Unit: {this.state.unitUnprocessed},
                                        Building:{" "}
                                        {this.state.buildingUnprocessed}, Floor:{" "}
                                        {this.state.floorUnprocessed}) could not
                                        be processed.
                                        <br />
                                        Reason: {this.state.errorMessage}
                                        <br />
                                        Re-upload the CSV after fixing line 2.
                                    </p>
                                ) : (
                                    <p>
                                        Line {this.state.lastProcessed + 1}{" "}
                                        (Unit: {this.state.unitUnprocessed},
                                        Building:{" "}
                                        {this.state.buildingUnprocessed}, Floor:{" "}
                                        {this.state.floorUnprocessed}) could not
                                        be processed.
                                        <br />
                                        Reason: {this.state.errorMessage}
                                        <br />
                                        Re-upload the CSV after fixing line{" "}
                                        {this.state.lastProcessed + 1} and
                                        removing lines 2-
                                        {this.state.lastProcessed}.
                                    </p>
                                )}
                            </MDBModalBody>
                        </MDBModal>
                    </>
                ) : (
                    ""
                )}
                {this.state.loading_upload === true ? (
                    <div
                        className="overlay"
                        id="overlay"
                        style={{ display: "block" }}
                    >
                        <div className="overlayProgressBar">
                            <MDBProgress
                                material
                                value={this.state.progress}
                                height="20px"
                                color="danger"
                                striped
                            />
                        </div>
                    </div>
                ) : (
                    ""
                )}
                <MDBModalHeader toggle={this.props.toggleUploadUnits}>
                    <h4>Bulk Upload Units</h4>
                </MDBModalHeader>
                <MDBModalBody>
                    <div className="venueSelector">
                        <MDBRow>
                            <MDBCol col="6" sm="12" lg="4">
                                <h5>Venue Name:</h5>
                            </MDBCol>
                            <MDBCol col="6" sm="12" lg="8">
                                <SelectSearch
                                    id="selectVenue"
                                    search={true}
                                    filterOptions={fuzzySearch}
                                    options={this.props.optionTemplateVenues}
                                    isOptionSelected={true}
                                    inputId="venueArray"
                                    classNamePrefix="venue-select"
                                    placeholder="Select..."
                                    onChange={this.props.handleSelectVenue}
                                    value={
                                        this.props.clearDropDown === true
                                            ? ""
                                            : this.props.venueID
                                    }
                                    // value={this.props.venueID}
                                />
                            </MDBCol>
                        </MDBRow>
                        <br />
                        <p>
                            Please note, only CSV files are accepted for the
                            upload. Fields marked with "*" in template are
                            required.
                        </p>
                        <p>
                            <strong>For special characters (ñ, é, ü, etc.):</strong> Save your CSV as "CSV UTF-8" in Excel or ensure UTF-8 encoding in other editors.
                        </p>
                        <p className="updateNote">
                         The template was updated on 12/17/24, please ensure you are using the most recent template before processing your upload.
                        </p>
                    </div>
                    <div
                        className="text-right submitButton"
                        key={this.state.theInputKey || ""}
                    >
                        <MDBBtn
                            color="danger"
                            onClick={() =>
                                this.exportCSVFile(
                                    headers,
                                    itemsFormatted,
                                    fileTitle
                                )
                            }
                        >
                            Download Template
                        </MDBBtn>
                        <MDBBtn
                            color="danger"
                            disabled={this.props.clearDropDown}
                        >
                            Upload Units
                            <CSVReader
                                cssclassName="csv-reader-input"
                                onFileLoaded={this.convertCSV}
                                parserOptions={papaparseOptions}
                                inputId="csvVenueUnitUploadData"
                                inputStyle={{ color: "transparent" }}
                            />
                        </MDBBtn>
                        <MDBBtn
                            color="primary"
                            onClick={this.props.toggleUploadUnits}
                        >
                            Close
                        </MDBBtn>
                    </div>
                </MDBModalBody>
            </>
        );
    }
}
export default BulkUploadUnits;
